<template>
  <div class="comment-main" :style="report ? 'border: 1px solid;' : null">
    <div class="comment-head">
      <b-avatar :size="28" />
      <p class="author">{{ authorFullname }}</p>
      <div class="comment-info">
        <p><em>{{ commentCreatedAt }}</em></p>
      </div>
    </div>
    <div class="comment-body">
      <div class="comment">
        <b-icon icon="arrow-return-right" />
        <p>{{ comment.comment }}</p>
      </div>
      <div v-if="ticket_id" class="file-add" @click="openModal(true, 'add-file', { ticket_id: ticket_id, comment_id: comment.id })">
        <span>
          <b-icon icon="files"></b-icon>
          {{$t('ticket.comment.addFile')}}
        </span>
      </div>
    </div>
    <div v-if="isAnyFile && !report" class="comment-footer">
      <p>{{$t('ticket.comment.files')}}: </p>
      <div class="download-links">
        <b-icon scale="1.25" rotate="45" icon="paperclip"></b-icon>
        <a :href="file" download="comment-file">İndirilebilir Dosya</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Modals from '../modals'
import i18n from '@/plugins/i18n';

export default {
  components: {
    Modals
  },
  data() {
    return {
      file: null
    }
  },
  props: {
    ticket_id: Number,
    comment: Object,
    openModal: Function,
    report: Boolean
  },
  computed: {
    authorFullname() {
      const fullname = this.comment.user.FirstName ? 
      `${this.comment.user.FirstName} 
       ${this.comment.user.LastName}` : 
      `${i18n.t('ticket.user')} ${this.comment.user.ID}` 
      return fullname
    },
    isAnyFile() {
      return this.comment.file_url
    },
    commentCreatedAt() {
      return moment(String(this.comment.created_at)).format("DD.MM.YYYY HH:mm");
    }
  },
  methods: {
    async getDownloadLink() {
      const path = this.comment.file_url
      if(!path) return
      const file = await this.$store.dispatch('getTicketFileUrl', path)
      this.file = file
    }
  },
  created() {
    this.getDownloadLink()
  }
};
</script>

<style>
@import "../styles/comment-card.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/components/CommentCard.vue